import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { documentsDic } from "../../../../../utils/dataDictionary";
import { toMoney, formatRut } from "../../../../../utils/formatter";
import exclamationIcon from "../../../../../assets/sidebarRightIcons/Exclamation.png";
import moment from "moment";
import { Popup, Icon } from 'semantic-ui-react'
import { importOpenSidebar } from "../../../../../redux/actions/openSidebar";

export default function RowInformProvider({
  selectedDTEsByClient,
  totalToPay,
}) {
  return (
    <>
      {selectedDTEsByClient?.map((element, index) => {
        const lastItem =
          selectedDTEsByClient?.length - 1 === index ? true : false;
        return (
          <>
            <DetailComponent
              lastItem={lastItem}
              selectedIndex={index}
              element={element}
              totalToPay={totalToPay}
              selectedDTEsByClient={selectedDTEsByClient}
              key={index}
              showAgendaAlert={element?.inAgenda}
            />
          </>
        );
      })}
    </>
  );
}

const DetailComponent = ({
  lastItem,
  selectedIndex,
  element,
  totalToPay,
  selectedDTEsByClient,
  showAgendaAlert,
}) => {
  const dispatch = useDispatch();
  const [showDetail, setShowDetail] = useState(false);


  const addInAgenda = (data) => {
    const editData = { 
        rut: data.rut, 
        name: data.name, 
        isProvider: true, 
        isClient: false, 
        paymentDaysClient: 0, 
        paymentDaysProvider: 30,
        bankAccountType: "corriente",
        bankRut: data.rut,
      }
    dispatch(importOpenSidebar({ show: true, newAgenda: true, editData, nomina: true }));
  };

  return (
    <>
      <div
        className={`${
          (selectedIndex % 2 == 0 ? "bg-row-detail1 " : "bg-row-detail2 ") +
          (lastItem && !showDetail
            ? "informProviderBackground__container__bodyContainer__lastElement"
            : "informProviderBackground__container__bodyContainer")
        }`}
        key={selectedIndex}
        onClick={() => setShowDetail(!showDetail)}
      >
        <div
          className="informProviderBackground__container__bodyContainer__itemRut"
          key={selectedIndex + "rut"}
        >
          {formatRut(element?.rut)}
        </div>
        <div
          className="informProviderBackground__container__bodyContainer__item"
          key={selectedIndex + "name"}
        >
          {!showAgendaAlert ? (
            <>
            <Popup
              content="Agregar a Agenda"
              position="bottom center"
              inverted
              trigger={
                <Icon 
                  name="address book"
                  color="yellow"
                  style={{ fontSize: "1.2em" }}
                  className="cursor-pointer"
                  size="big"
                  onClick={() => addInAgenda(element)}
              /> 
            }
            />
            </>
          ) : (
            ""
          )}
          {element?.name || "PROVEEDOR DESCONOCIDO"}
        </div>
        <div
          className="informProviderBackground__container__bodyContainer__itemAmount"
          key={selectedIndex + "amount"}
        >
          {totalToPay(element?.DTEs)}
        </div>
        <div
          className="informProviderBackground__container__bodyContainer__lastItem"
          key={selectedIndex + "docNum"}
        >
          {element?.DTEs?.length}
        </div>
      </div>
      {showDetail ? (
        <div className="informProviderBackground__container__bodyContainer__detailContainer">
          {element?.DTEs?.map((DTEs, index) => {
            const lastDetail =
              element?.DTEs?.length - 1 === index ? true : false;
            const lastOfAll =
              selectedDTEsByClient?.length - 1 === selectedIndex ? true : false;
            const specialFirstClass =
              lastDetail && lastOfAll
                ? "informProviderBackground__container__bodyContainer__detailContainer__detailBodyContainer__lastFirstBodyComponent"
                : "informProviderBackground__container__bodyContainer__detailContainer__detailBodyContainer__bodyComponent";

            const roundedBorder =
              lastDetail && lastOfAll
                ? "informProviderBackground__container__bodyContainer__detailContainer__detailBodyContainerRounded"
                : "informProviderBackground__container__bodyContainer__detailContainer__detailBodyContainer";

            return (
              <div
                className={`${
                  (index % 2 == 0
                    ? "bg-row-innerDetail1 "
                    : "bg-row-innerDetail2 ") + roundedBorder
                }`}
              >
                <div className={specialFirstClass}>
{/*                   <span className="dteInformed">
                    {DTEs?.inform?.isInform ? (
                      <>
                       <Popup
                         content={`En proceso de pago, monto informado ${toMoney(DTEs?.inform?.amountInform)}`}
                         position="bottom center"
                         inverted
                         trigger={
                           <Icon 
                             name="exclamation circle"
                             color="yellow"
                             style={{ fontSize: "1.2em" }}
                             className="cursor-pointer"
                             size="big"
                         /> 
                       }
                       />
                      </>
                    ) : (
                      <div className="informedDTE"></div>
                    )}
                  </span> */}
                  <span>
                    <span className="docPillsNumber">
                      {DTEs?.documentNuber}
                    </span>
                    <span className="docPillsType">
                      {documentsDic[DTEs?.documentCode]?.label}
                    </span>
                  </span>
                </div>
                <div className="informProviderBackground__container__bodyContainer__detailContainer__detailBodyContainer__bodyComponent">
                  {moment(DTEs?.expiration).format("DD/MM/YYYY")}
                </div>
                <div className="informProviderBackground__container__bodyContainer__detailContainer__detailBodyContainer__lastBodyComponent">
                  {toMoney(DTEs?.amountSelected)}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="informProviderBackground__container__bodyContainer__detailContainer__hiddenDetail"></div>
      )}
    </>
  );
};
